import React from 'react';

const PropsLogger = props => {
  // eslint-disable-next-line no-console
  console.log('proplogger', props);
  return <></>;
};

export default PropsLogger;
